<div class="watchlist-container">
  <app-title-container>
    <h1>Watchlist Companies</h1>
  </app-title-container>

  <app-divider height="2px"></app-divider>
  @if (isLoading()) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  } @else {
    <div class="second-actions-container">
      <button class="clickable-text-btn ml-auto" (click)="exportExcel()" [disabled]="isLoadingExport()" aria-label="Export to Excel">
        @if (isLoadingExport()) {
          <mat-icon class="clickable-text-btn-icon"><mat-spinner diameter="15"></mat-spinner></mat-icon>
        } @else {
          <mat-icon fontSet="material-symbols-outlined" class="clickable-text-btn-icon"> file_export </mat-icon>
        }

        Export to Excel
      </button>
    </div>

    <div class="table-container">
      <app-watchlists-table
        [colDefs]="companyColumnDefs()"
        [rowData]="rowData()?.companyWatchlistTableContent ?? []"
        [defaultColDef]="{ flex: 1, minWidth: 100 }"
        (rowClicked)="onRowClicked($event)"
      ></app-watchlists-table>
    </div>
  }
</div>
